if (window.location.host === '0.0.0.0:9000') {
  setInterval(() => {
    const jivoElem = document.querySelector('jdiv');
    if (jivoElem) {
      jivoElem.remove();
    }
  }, 1000);
}